/*global _gat ga*/
/*eslint no-underscore-dangle: ["off"]*/
/**
 * Apply Google Analytics cross-domain tracking for the specified url
 *
 * @param {string} url The absolute URL to decorate
 *
 * @return {string} the decorated url
 */
export default function applyTracking (url) {
	if (typeof(_gat) !== 'undefined') {
		var pageTracker = _gat._getTrackerByName();
		url = pageTracker._getLinkerUrl(url);
	} else if (typeof ga === 'function') {
		ga(function (tracker) {
			if (typeof tracker === 'undefined') {
				tracker = ga.getAll()[0];
			}
			var linker = new window.gaplugins.Linker(tracker);

			url = linker.decorate(url);
		});
	}

	return url;
}
